export { default as ReactSelectComponent } from './select.component'
